import { BlockTimeSetting } from '../types/Study';
import { User, UserExam } from '../types/User';
import { formatAccommodation } from './accommodationUtils';
import { useUserExamUpdate } from './updateUserExam';

export const useHandleContentTypeChange = (
  currentUser: User | null,
  primaryExam: UserExam | undefined
) => {
  const { updateExam } = useUserExamUpdate();

  return (type: 'flashcard' | 'qbank') => {
    if (!currentUser?.id || !primaryExam?.id) {
      return;
    }

    if (type === 'flashcard') {
      const newFlashcardEnabled = !primaryExam?.isUsingFlashcards;
      const newQbankEnabled = newFlashcardEnabled
        ? primaryExam?.isUsingQbank
        : true;

      updateExam({
        userId: currentUser?.id,
        examId: primaryExam?.id,
        isUsingFlashcards: newFlashcardEnabled,
        isUsingQbank: newQbankEnabled,
      });
    } else {
      const newQbankEnabled = !primaryExam?.isUsingQbank;
      const newFlashcardEnabled = newQbankEnabled
        ? primaryExam?.isUsingFlashcards
        : true;

      updateExam({
        userId: currentUser?.id,
        examId: primaryExam?.id,
        isUsingFlashcards: newFlashcardEnabled,
        isUsingQbank: newQbankEnabled,
      });
    }
  };
};

export const renderAccommodations = (currentUser: User | null) => {
  if (!currentUser || currentUser?.preferredBlockType === 'tutor') {
    return null;
  }
  if (currentUser?.preferredBlockTimeSetting !== BlockTimeSetting.default) {
    return (
      <div className="accommodations">
        <span>
          {formatAccommodation(currentUser?.preferredBlockTimeSetting, true)}{' '}
          Time
        </span>
      </div>
    );
  }
};
